import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useBoolModalState } from '@app/core';
import { AddPaymentMethod } from './AddPaymentMethod';
import { AddButton } from '@app/form';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  addPaymentMethodContainer: {
    marginBottom: theme.marginBase * 2,
    backgroundColor: theme.colors.grayBackground,
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
  },
}));

interface Props {
  organizationId: string;
  selectableStyle?: boolean;
  sessionId?: string;
  onSuccess?: (pm: string) => any;
}

export const AddPaymentMethodButton = ({
  organizationId,
  selectableStyle,
  sessionId,
  onSuccess,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [adding, openNewPaymentMethod, closeNewPaymentMethod] =
    useBoolModalState();

  const onAdded = useCallback(
    (pm: string) => {
      closeNewPaymentMethod();
      if (onSuccess) {
        onSuccess(pm);
      }
    },
    [onSuccess, closeNewPaymentMethod],
  );

  return adding ? (
    <div className={classes.addPaymentMethodContainer}>
      <AddPaymentMethod
        organizationId={organizationId}
        onSuccess={onAdded}
        onCancel={closeNewPaymentMethod}
        selectableStyle={selectableStyle}
        sessionId={sessionId}
      />
    </div>
  ) : (
    <AddButton
      text={t('billing.paymentMethod.add.title')}
      onClick={openNewPaymentMethod}
      buttonClassName={classes.addPaymentMethodContainer}
    />
  );
};
